import { Box, Button, Collapse, Stack } from "@mui/material"
import { Link, useLocation } from "react-router-dom"
import Icons from "../../../assets/js/Icons"

function SidebarMenu({ menu, activeIndex, setActiveIndex, index, sidebarDeActive }) {
  const isActive = activeIndex === index
  const { pathname } = useLocation()

  return (
    <Box>
      {menu?.menus ?
        <Button
          variant={
            menu?.menus?.map(
              ({ path }) => (path)
            ).includes(pathname) ?
              "activeSidebarMenu" : "sidebarMenu"
          }
          sx={{
            ".MuiButton-endIcon": {
              transition: "all 400ms ease",
              transform: isActive ? "rotate(180deg)" : "rotate(0deg)"
            },
            // ":hover svg": { transform: "rotate(180deg)" }
          }}
          startIcon={menu?.icon || null}
          endIcon={<Icons.ArrowDownSharp />}
          onClick={() => setActiveIndex(isActive ? null : index)}
        >{menu?.name}
        </Button> :
        <Button
          to={menu?.path}
          LinkComponent={Link}
          onClick={sidebarDeActive}
          startIcon={menu?.icon || null}
          variant={menu?.path === pathname ? "activeSidebarMenu" : "sidebarMenu"}
        >{menu?.name}
        </Button>
      }
      {menu?.menus &&
        <Collapse
          in={isActive}
          timeout={300}
          unmountOnExit
          sx={{
            mt: 1,
            pl: 1.25,
            ml: "20px",
            borderLeft: "2px solid #ffffff45",
          }}
        >
          <Stack spacing={1}>
            {menu?.menus?.map((item, i) => (
              <Button
                key={i}
                to={item?.path}
                LinkComponent={Link}
                sx={{
                  position: "relative",
                  "::before": {
                    top: "50%",
                    width: "4px",
                    content: "''",
                    left: "-13px",
                    height: "18px",
                    borderRadius: "4px",
                    position: "absolute",
                    transform: "translateY(-50%)",
                    bgcolor: item?.path === pathname ? "primary.main" : "#52555d",
                  },
                  bgcolor: item?.path === pathname ? "#ffffff24" : "transparent",
                }}
                variant="sidebarMenu"
                onClick={sidebarDeActive}
              // variant={item?.path === pathname ? "activeSidebarMenu" : "sidebarMenu"}
              >{item?.name}
              </Button>
            ))
            }
          </Stack>
        </Collapse>
      }
    </Box>
  )
}

export default SidebarMenu